// Shared color utilities
// Converts a full 6-digit hex color (with or without leading #) to an RGB string "r, g, b".
// Returns null for invalid input.
export function hexToRgb(hex: string): string | null {
  if (!hex) return null;
  const normalized = hex.startsWith("#") ? hex : `#${hex}`;
  const result = /^#?([a-fA-F\d]{2})([a-fA-F\d]{2})([a-fA-F\d]{2})$/i.exec(
    normalized,
  );
  return result
    ? `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
    : null;
}
